import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ViewerMode } from '../../../../core/models/model-viewer/viewer.models';

export interface ControlAction {
  type:
    | 'gizmo'
    | 'marker'
    | 'save'
    | 'undo'
    | 'clear'
    | 'draw'
    | 'select'
    | 'update'
    | 'delete'
    | 'toggle'
    | 'metrics';
  payload?: any;
}

@Component({
  selector: 'app-marker-controls',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './marker-controls.component.html',
  styleUrls: ['./marker-controls.component.scss'],
})
export class MarkerControlsComponent {
  @Input() viewerMode: ViewerMode = 'NONE';
  @Input() count: number = 0;
  @Input() markersVisible: boolean = true;
  @Input() allowAnnotation: boolean = true;

  @Input() isGizmoMode: boolean = false;
  @Input() isAddMarkerMode: boolean = false;

  @Input() isDrawing2DMode: boolean = false;
  @Input() isMetricsActive: boolean = false;

  @Input() hide2DToolbar: boolean = false;
  @Input() hide3DDeleteButton: boolean = false;

  @Output() action = new EventEmitter<ControlAction>();
  @Input() selectedMarkerId: string | number | null = null;

  onGizmoClick(): void {
    this.action.emit({ type: 'gizmo' });
  }

  onMarkerClick(): void {
    this.action.emit({ type: 'marker' });
  }

  onSaveClick(): void {
    this.action.emit({ type: 'save' });
  }

  onUndoClick(): void {
    this.action.emit({ type: 'undo' });
  }

  onClearClick(): void {
    this.action.emit({ type: 'clear' });
  }

  onDrawClick(): void {
    this.action.emit({ type: 'draw' });
  }

  onSelectClick(): void {
    this.action.emit({ type: 'select' });
  }

  onDeleteSelectedClick(): void {
    if (this.selectedMarkerId) {
      this.action.emit({
        type: 'delete',
        payload: this.selectedMarkerId,
      });
    }
  }

  onUpdateClick() {
    if (this.selectedMarkerId) {
      this.action.emit({
        type: 'update',
        payload: this.selectedMarkerId,
      });
    }
  }

  get isDeleteDisabled(): boolean {
    return (
      this.selectedMarkerId === 0 ||
      this.selectedMarkerId === null ||
      this.selectedMarkerId === undefined
    );
  }

  onToggleClick(): void {
    this.action.emit({ type: 'toggle' });
  }

  onMetricsClick(): void {
    this.action.emit({ type: 'metrics' });
  }
}
